import React from 'react'

import styles from '../style/ProfileSkeleton.module.css';

const DevProfileSkeleton = () => {
    return (
        <>
            <div className={`row`}>
                <div className={`${styles.skeletonRow}`}>
                    <div className={`${styles.skeleton} ${styles.skeletonLabel}`}></div>
                    <div className={`${styles.skeleton} ${styles.skeletonValue}`}></div>
                </div>
                <div className={`${styles.skeletonRow}`}>
                    <div className={`${styles.skeleton} ${styles.skeletonLabel}`}></div>
                    <div className={`${styles.skeleton} ${styles.skeletonValue}`}></div>
                </div>
                <div className={`${styles.skeletonRow}`}>
                    <div className={`${styles.skeleton} ${styles.skeletonLabel}`}></div>
                    <div className={`${styles.skeleton} ${styles.skeletonValueTags}`}>
                        <div className={`${styles.skeleton} ${styles.skeletonTag}`}></div>
                        <div className={`${styles.skeleton} ${styles.skeletonTag}`}></div>
                        <div className={`${styles.skeleton} ${styles.skeletonTag}`}></div>
                    </div>
                </div>
                <div className={`${styles.skeletonRow}`}>
                    <div className={`${styles.skeleton} ${styles.skeletonLabel}`}></div>
                    <div className={`${styles.skeleton} ${styles.skeletonValueButtons}`}>
                        <div className={`${styles.skeleton} ${styles.skeletonButton}`}></div>
                        <div className={`${styles.skeleton} ${styles.skeletonButton}`}></div>
                    </div>
                </div>
                <div className={`${styles.skeletonRow}`}>
                    <div className={`${styles.skeleton} ${styles.skeletonLabel}`}></div>
                    <div className={`${styles.skeleton} ${styles.skeletonValue}`}></div>
                </div>
                <div className={`${styles.skeletonRow}`}>
                    <div className={`${styles.skeleton} ${styles.skeletonLabel}`}></div>
                    <div className={`${styles.skeleton} ${styles.skeletonPassword}`}></div>
                </div>
            </div>
        </>
    )
}

export default DevProfileSkeleton